<template>
  <svg v-if="desc" :class="'icon icon-' + type" focusable="false" :aria-labelledby="'i_' + uuid">
    <desc :id="'i_' + uuid">{{ desc }}</desc>
    <use :xlink:href="iconUrl + '#icon-' + type"></use>
  </svg>
  <svg v-else :class="'icon icon-' + type" aria-hidden="true" focusable="false">
    <use :xlink:href="iconUrl + '#icon-' + type"></use>
  </svg>
</template>

<script>
export default {
  name: "Icon",
  props: {
    type: {
      type: String,
      required: true,
    },
    iconUrl: {
      type: String,
      required: false,
      default: document.body.getAttribute("data-icon-path"),
    },
    desc: String,
  },
  computed: {
    uuid() {
      return crypto.randomUUID();
    },
  },
};
</script>
